import { useApiMutation } from '../../../hooks/useApiMutation';
import { deleteTemplate } from '../api/logbookApi';
import { UseApiMutationOptions } from '../types/loogBookTypes';

type MutationResponse = { message: string };
type MutationVariables = string;

/**
 * [Responsibility: API Mutation]
 * A dedicated hook for deleting a logbook template via the API.
 * @param options - Configuration options for the mutation.
 */
export const useDeleteLogbookTemplate = (
  options?: UseApiMutationOptions<MutationResponse, Error, MutationVariables>,
  invalidateQueryKey?: any
) => {
  return useApiMutation<MutationResponse, Error, MutationVariables>(deleteTemplate, {
    successMessage: 'Logbook template deleted successfully',
    errorMessage: 'Failed to delete logbook template',
    invalidateQueryKeys: [invalidateQueryKey],
    ...options,
  });
};
